import createIcon from '../../createIcon';

/**
 * @component @name Looks
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMTAuNUM4LjE0IDEwLjUgNSAxMy42NCA1IDE3LjVIN0M3IDE0Ljc0IDkuMjQgMTIuNSAxMiAxMi41QzE0Ljc2IDEyLjUgMTcgMTQuNzQgMTcgMTcuNUgxOUMxOSAxMy42NCAxNS44NiAxMC41IDEyIDEwLjVaTTEyIDYuNUM1LjkzIDYuNSAxIDExLjQzIDEgMTcuNUgzQzMgMTIuNTQgNy4wNCA4LjUgMTIgOC41QzE2Ljk2IDguNSAyMSAxMi41NCAyMSAxNy41SDIzQzIzIDExLjQzIDE4LjA3IDYuNSAxMiA2LjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Looks = createIcon('Looks', [
  [
    'path',
    {
      d: 'M12 10.5C8.14 10.5 5 13.64 5 17.5H7C7 14.74 9.24 12.5 12 12.5C14.76 12.5 17 14.74 17 17.5H19C19 13.64 15.86 10.5 12 10.5ZM12 6.5C5.93 6.5 1 11.43 1 17.5H3C3 12.54 7.04 8.5 12 8.5C16.96 8.5 21 12.54 21 17.5H23C23 11.43 18.07 6.5 12 6.5Z',
      key: 'cdm709',
    },
  ],
]);

export default Looks;
